module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.items), function(item) {
    return (_vm.mold === 'thumbnail') ? [_c('router-link', {
      staticClass: "thumbnail",
      attrs: {
        "to": {
          name: 'DetailView',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('img', {
      attrs: {
        "src": item.image_hlarge,
        "alt": "cover"
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("subStr")(item.content)))])]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.category_name))]), _vm._v(" "), (item.subcategory_name) ? _c('span', {
      staticClass: "label"
    }, [_vm._v("\n          本活动来自栏目 " + _vm._s(item.subcategory_name) + "\n        ")]) : _vm._e()])])] : _vm._e()
  }), _vm._v(" "), (_vm.mold === 'basic') ? [_c('ul', {
    staticClass: "basic"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item.comments))])])])
  }))] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e3bee70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 201
// module chunks = 0